// SI Metric Prefixes with conversion factors (base = 1, no prefix)
export const prefixesUnits = [
  { id: 'yotta', name: 'Yotta', symbol: 'Y', plural: 'Yotta', factor: 1e24 },
  { id: 'zetta', name: 'Zetta', symbol: 'Z', plural: 'Zetta', factor: 1e21 },
  { id: 'exa', name: 'Exa', symbol: 'E', plural: 'Exa', factor: 1e18 },
  { id: 'peta', name: 'Peta', symbol: 'P', plural: 'Peta', factor: 1e15 },
  { id: 'tera', name: 'Tera', symbol: 'T', plural: 'Tera', factor: 1e12 },
  { id: 'giga', name: 'Giga', symbol: 'G', plural: 'Giga', factor: 1e9 },
  { id: 'mega', name: 'Mega', symbol: 'M', plural: 'Mega', factor: 1e6 },
  { id: 'kilo', name: 'Kilo', symbol: 'k', plural: 'Kilo', factor: 1e3 },
  { id: 'hecto', name: 'Hecto', symbol: 'h', plural: 'Hecto', factor: 1e2 },
  { id: 'deka', name: 'Deka', symbol: 'da', plural: 'Deka', factor: 1e1 },
  { id: 'base', name: 'Base (No Prefix)', symbol: '1', plural: 'Base', factor: 1 },
  { id: 'deci', name: 'Deci', symbol: 'd', plural: 'Deci', factor: 1e-1 },
  { id: 'centi', name: 'Centi', symbol: 'c', plural: 'Centi', factor: 1e-2 },
  { id: 'milli', name: 'Milli', symbol: 'm', plural: 'Milli', factor: 1e-3 },
  { id: 'micro', name: 'Micro', symbol: 'µ', plural: 'Micro', factor: 1e-6 },
  { id: 'nano', name: 'Nano', symbol: 'n', plural: 'Nano', factor: 1e-9 },
  { id: 'pico', name: 'Pico', symbol: 'p', plural: 'Pico', factor: 1e-12 },
  { id: 'femto', name: 'Femto', symbol: 'f', plural: 'Femto', factor: 1e-15 },
  { id: 'atto', name: 'Atto', symbol: 'a', plural: 'Atto', factor: 1e-18 },
  { id: 'zepto', name: 'Zepto', symbol: 'z', plural: 'Zepto', factor: 1e-21 },
  { id: 'yocto', name: 'Yocto', symbol: 'y', plural: 'Yocto', factor: 1e-24 },
];

export const popularPrefixesConversions = [
  { from: 'kilo', to: 'base' },
  { from: 'mega', to: 'kilo' },
  { from: 'giga', to: 'mega' },
  { from: 'milli', to: 'micro' },
  { from: 'micro', to: 'nano' },
  { from: 'tera', to: 'giga' },
];

export const getUnitById = (id) => prefixesUnits.find(unit => unit.id === id);

export const convertPrefixes = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.name} to ${toUnit.name}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} prefix converter. Instantly convert SI metric prefixes and learn the conversion formula.`;
};
